import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import{BrowserRouter,HashRouter} from 'react-router-dom';
import AppRouter from './components/AppRouter';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';

//ReactDOM.render(<AppRouter store={store} />, document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppRouter store={store} />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
